type InsensitiveSearchParams = {
  key: string
  value: string | null
  exists: boolean
}

export const getInsensitiveSearchParams = (
  searchParams: URLSearchParams,
  searchKey: string,
): InsensitiveSearchParams => {
  searchKey = searchKey.toLowerCase()

  let insensitiveSearchParamsData: InsensitiveSearchParams = {
    key: "",
    value: null,
    exists: false,
  }

  for (const [key, value] of searchParams.entries()) {
    if (key.toLowerCase() === searchKey) {
      insensitiveSearchParamsData = {
        key,
        value,
        exists: true,
      }
    }
  }

  return insensitiveSearchParamsData
}
